import httpClient from '../../services/http-client';
import { API_SUB_URL_SCHEDULE_MEDICAL } from '../../constants';
import { fetchDataRequest, fetchDataSuccess, fetchDataError } from '../actions';
import { 
    FETCH_DATA_REQUEST, FETCH_DATA_ERROR,
    ADD_NEW_SCHEDULE_MEDICAL, LOAD_LIST_SCHEDULE_MEDICAL, LOAD_A_SCHEDULE_MEDICAL, UPDATE_A_SCHEDULE_MEDICAL, DELETE_A_SCHEDULE_MEDICAL
} from '../actionTypes';

export const apiLoadListScheduleMedical = (params) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));
        
        let query = "";

        Object.keys(params).map(key => {
            if(params[key]) {
                query += (query.length > 0 ? "&&" : "") + (`${key}=` + params[key]);
            }
        });

        httpClient.get(`${API_SUB_URL_SCHEDULE_MEDICAL}?${query}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_LIST_SCHEDULE_MEDICAL, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiLoadAScheduleMedical = ({ id }) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.get(`${API_SUB_URL_SCHEDULE_MEDICAL}/${id}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_A_SCHEDULE_MEDICAL, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiLoadAScheduleMedicalByScheduleNumber = ({ id }) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.get(`${API_SUB_URL_SCHEDULE_MEDICAL}/schedule_number/${id}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_A_SCHEDULE_MEDICAL, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiCreateNewScheduleMedical = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.post(API_SUB_URL_SCHEDULE_MEDICAL, payload)
            .then(response => {
                dispatch(fetchDataSuccess(ADD_NEW_SCHEDULE_MEDICAL, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiUpdateAScheduleMedical = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.put(`${API_SUB_URL_SCHEDULE_MEDICAL}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(UPDATE_A_SCHEDULE_MEDICAL, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiDeleteAScheduleMedical = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.delete(`${API_SUB_URL_SCHEDULE_MEDICAL}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(DELETE_A_SCHEDULE_MEDICAL, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};